import React from 'react';
import { useConfig } from '../context/ConfigContext';
import { useAuth } from '../context/AuthContext';

const WelcomeLetter = () => {
    const { config } = useConfig();
    const { user } = useAuth();

    const welcomeType = config?.event_letters?.welcomeType || 'structured';
    const welcomeImageUrl = 'https://ftp.pcnpublicidad.com/neuroupdate/resources/CartaLogistica_4toNeuroupdate.png';
    const structuredData = config?.event_letters?.structuredData || [
        {
            title: 'Traslados',
            icon: '✈️',
            content: 'Traslados aeropuerto en Santa Marta – Hotel – aeropuerto. Personal identificado con una paleta y el logo de Adium.',
            borderColor: '#FFD700'
        },
        {
            title: 'Hospedaje',
            icon: '🏨',
            content: 'Hospedaje en ocupación sencilla, en Hotel Irotama.\n\n**Check In:** 23/04/2026\n**Check Out:** 25/04/2026',
            borderColor: '#00ced1'
        },
        {
            title: 'Alimentación',
            icon: '🍽️',
            content: '**Alimentación:** Incluida los días del evento.',
            borderColor: '#ff4d4d'
        },
        {
            title: 'Cena corporativa',
            icon: '👔',
            content: '**Fecha:** 24 de abril.\n**Hora:** 17:45.\n**Lugar:** Sunset en la playa.\n\n**Recomendaciones:** Zapatos cómodos, no llevar tacones ya que la cena será en la playa.\n***Dresscode:** Business casual.\n\nAl ser un evento totalmente científico por Compliance **no están autorizados los acompañantes.**',
            borderColor: '#FFD700'
        }
    ];

    const welcomeText = config?.event_letters?.welcome || '';
    const formattedText = welcomeText
        .replace(/{name}/g, user?.name || '')
        .replace(/{lastName}/g, user?.last_name || '');

    if (welcomeType === 'image') {
        return (
            <div className="w-[90%] mx-auto pt-[5%] pb-10 animate-fadeIn flex justify-center">
                <img
                    src={welcomeImageUrl}
                    alt="Carta Logística"
                    className="w-full h-auto rounded-[40px] shadow-2xl border border-white/10"
                />
            </div>
        );
    }

    if (welcomeType === 'text') {
        return (
            <div className="max-w-[90%] mx-auto py-10 px-4 animate-fadeIn">
                <div className="bg-white/10 backdrop-blur-xl p-10 rounded-[40px] border border-white/10 shadow-2xl">
                    <div className="prose prose-invert max-w-none text-white/90 whitespace-pre-line">
                        {formattedText}
                    </div>
                </div>
            </div>
        );
    }

    // Structured Design
    return (
        <div className="max-w-[90%] mx-auto py-10 px-4 animate-fadeIn space-y-12 pb-20 relative">
            {/* Header Box */}
            <div className="flex justify-end relative z-10">
                <div className="bg-gradient-to-l from-[#3a0e5c] to-[#9b1eb9] px-10 py-3 rounded-l-none rounded-r-none rounded-tl-md rounded-bl-md shadow-lg transform translate-x-4">
                    <h2 className="text-white text-xl font-black uppercase tracking-tighter italic">Aspectos logísticos</h2>
                </div>
            </div>

            <div className="space-y-12 pt-4">
                {structuredData.map((item, idx) => (
                    <div
                        key={idx}
                        className="relative p-10 rounded-[40px] border-2 bg-black/30 backdrop-blur-md shadow-xl transition-transform hover:scale-[1.02] duration-300"
                        style={{ borderColor: item.borderColor || 'rgba(255,255,255,0.1)' }}
                    >
                        {/* Title Centered on Top Border */}
                        <div className="absolute -top-5 left-1/2 -translate-x-1/2 px-8 py-1 bg-[#1c0042] rounded-full">
                            <h3 className="text-2xl font-black italic uppercase tracking-tighter whitespace-nowrap" style={{ color: item.borderColor }}>
                                {item.title}
                            </h3>
                        </div>

                        <div className="flex gap-8 items-center pt-2">
                            <div className="w-20 h-20 flex-shrink-0 flex items-center justify-center bg-white/5 rounded-2xl border border-white/10 text-5xl">
                                {item.icon}
                            </div>
                            <div className="flex-grow">
                                <div className="text-white/90 text-sm font-medium leading-relaxed whitespace-pre-line">
                                    {item.content.split('\n').map((line, i) => {
                                        const parts = line.split(/(\*\*.*?\*\*)/);
                                        return (
                                            <p key={i}>
                                                {parts.map((part, j) =>
                                                    part.startsWith('**') && part.endsWith('**')
                                                        ? <strong key={j} className="text-white font-black">{part.slice(2, -2)}</strong>
                                                        : part
                                                )}
                                            </p>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

        </div>
    );
};

export default WelcomeLetter;
